/**
 * Langues publiées dont l'image n'a pas de description (texte alternatif).
 * Figma admin : « Alt obligatoires sur les images » ; RGAA 1.2 / 1.3.
 */
export function findLanguagesMissingImageAlt({
  languages,
  hasImage,
  imageAlt,
  status,
}: {
  languages: string[];
  hasImage: boolean;
  imageAlt: Partial<Record<string, string>>;
  status: Partial<Record<string, 'draft' | 'published'>>;
}): string[] {
  if (!hasImage) return [];
  return languages.filter((lang) => status[lang] === 'published' && !(imageAlt[lang] ?? '').trim());
}

/**
 * Descriptions à enregistrer : texte brut nettoyé pour les langues actives, les
 * autres langues gardent leur valeur ; sans image, plus de description.
 */
export function buildImageAlt({
  existing,
  imageAlt,
  activeLanguages,
  hasImage,
}: {
  existing?: Record<string, string>;
  imageAlt: Partial<Record<string, string>>;
  activeLanguages: string[];
  hasImage: boolean;
}): Record<string, string> {
  if (!hasImage) return {};
  const result: Record<string, string> = { ...(existing || {}) };
  activeLanguages.forEach((lang) => {
    const value = (imageAlt[lang] ?? '').replace(/\s+/g, ' ').trim();
    if (value) result[lang] = value;
    else delete result[lang];
  });
  return result;
}
